import { reactive } from 'vue'

export interface ToastMessage {
  id: string
  text: string
  tone: 'success' | 'error' | 'info'
}

const messages = reactive<ToastMessage[]>([])

function push(text: string, tone: ToastMessage['tone'] = 'info', duration = 4200): void {
  const id = crypto.randomUUID()
  messages.push({ id, text, tone })
  window.setTimeout(() => remove(id), duration)
}

function remove(id: string): void {
  const index = messages.findIndex((message) => message.id === id)
  if (index >= 0) messages.splice(index, 1)
}

export function useToast() {
  return {
    messages,
    success: (text: string) => push(text, 'success'),
    error: (text: string) => push(text, 'error', 6500),
    info: (text: string) => push(text, 'info'),
    remove
  }
}
